module.exports = __webpack_public_path__ + "c8f79db5dec0140ab80ab5d6cd17bfbc.svg";